export const PrivacyPolicyOfPOPSUP = `
<h3 class='head'>1. Purpose of policy</h3>
<div>
This Privacy Policy applies to the collection, use, disclosure and handling of personal information by POPSUP Global Investment Group Pty Ltd (“POPSUP Global”, “we” or “us”), including personal information collected via our https://www.popsup.global website (the “Website”).
​
POPSUP Global is committed to protecting the privacy of individuals and is bound by the Australian Privacy Principles set out in the Privacy Act 1988 (Commonwealth) (the “Act”).  This Privacy Policy outlines how we will collect, use, disclose and otherwise handle personal information.
​
Your use of the Website is also subject to the POPSUP Global Website Terms of Use.
</div>

<h3>2. Collection</h3>
<div>
POPSUP Global collects personal information from you in a number of different ways. We may collect personal information directly from you or in the course of our dealings with you, for example when you:
​
(a) provide personal information to us;
(b) browse or use our Website (including via cookies); or
(c) contact and correspond with us, for example to ask for information.
​
We may also collect personal information about you from other entities, from publicly available sources, or in some cases, from third parties.
​
We also collect sensitive information from you, which includes health information, where it is relevant to us providing goods or services to you.
​
The information may include (but may not be limited to) your name, contact details, Internet Protocol (IP) address, occupation, employer, areas of interest, and information relating to your dealings with us [and our partners]. The purposes for which we collect your information may include:
​
(a) verifying your identity;
(b) contacting you (including via electronic messaging such as SMS and email, by mail, by phone or in any other lawful manner);
(c) providing you with goods or services;
(d) developing and improving our services and obtaining feedback.
​
If we are not able to collect personal information about you we may not be able to provide you with products, services and assistance to the extent that they require us to collect, use or disclose personal information.
</div>

<h3>3. Use and disclosure</h3>
<div>
POPSUP Global may use or disclose your personal information for the purpose for which it was collected. We will also use and disclose your personal information for a secondary purpose that is related to a purpose for which we collected it, where you would reasonably expect us to use or disclose your personal information for that secondary purpose.
​
Other instances when we may use and disclose your personal information include where:
​
(a) to which you have expressly or impliedly consented to the use or disclosure;
(b) in confidence, to our advisers and insurers;
(c) in confidence, to third parties to improve our services and obtain feedback; and
(d) the use or disclosure is authorised or required by or under an Australian law or court/tribunal order.
​
We may also disclose your personal information to third parties, including:
​
(a) share your personal information amongst other entities;
(b) share your personal information with our advisors and consultants; and
(c) with third party service providers we use in conducting our business, subject to confidentiality provisions as we deem appropriate (including, without limitation, billing or data storage services, email filtering, virus scanning and other technology services providers, and archival services providers).
​
Some of the third parties to whom we disclose your personal information may be located outside Australia. For example, we may transfer your personal information to external national or overseas facilities in the course of data processing, back up and scanning or for the purposes of obtaining other services from third parties.
​
The countries in which these third parties are located will depend on the circumstances.  However, in the course of our ordinary business operations we commonly disclose personal information to third parties located in the following countries:
</div>

<h3>4. Information about events, the Website and our services</h3>
<div>
We may contact you via email, SMS or other means in order to provide you with updated information about the goods or services you have ordered from us, the Website, in relation to events or to provide you with other information about our services.  If you do not wish to receive any such information, please contact us as set out below.
</div>

<h3>5. The information we keep about you</h3>
<div>
You have a right to request access to or correction of your personal information held by us. If you wish to access, correct or update any personal information we may hold about you, please contact us as set out below. However, we may charge for providing access to this information and we may refuse access where the Act allows us to do so.
</div>

<h3>6. Complaints process</h3>
<div>
If you have any questions or concerns about our collection, use or disclosure of personal information, or if you believe that we have not complied with this Privacy Policy or the Act, please contact us as set out below.  When contacting us, please provide as much detail as possible in relation to the query, issue or complaint.
​
Your complaint will be taken seriously and will be assessed by an appropriate person with the aim of resolving any issue in a timely and efficient manner. We request that you cooperate with us during this process and provide us with relevant information we may require.

</div>

<h3>7. Storage and security of your personal information</h3>
<div>
We host and store our customer data electronically in our IT systems.  These may include Australian and internationally-based cloud servers or the servers of third parties within and outside of Australia.
​
POPSUP Global will take reasonable steps to keep any personal information we hold about you secure.  However, except to the extent liability cannot be excluded due to the operation of statute, we exclude all liability (including in negligence) for the consequences of any unauthorised access to your personal information. Please notify us immediately if you become aware of any breach of security.
</div>

<h3>8. Changes to this Privacy Policy</h3>
<div>
The date of this Privacy Policy is set out below. We may change this Privacy Policy at our discretion. By continuing to use the Website, or otherwise continuing to deal with us, you accept this Privacy Policy as it applies from time to time.
</div>

<h3>9. Contact us</h3>
<div>Please direct any privacy issues or queries to BD team at business@popsup.global</div>
`;
